import { __assign, __rest } from "tslib";
import * as React from 'react';
import { Box } from '../components/Box';
import { Button } from '../components/Button';
import { Popover } from '../components/Popover';
var Confirm = function (_a) {
    var text = _a.text, onOK = _a.onOK, onCancel = _a.onCancel, rest = __rest(_a, ["text", "onOK", "onCancel"]);
    return (React.createElement(Popover, __assign({}, rest, { onDismiss: onCancel }),
        React.createElement(Box, { mx: 2, mt: 2, fontSize: 3 }, text),
        React.createElement(Box, null,
            React.createElement(Button, { m: 2, size: "small", onClick: onCancel }, "Cancel"),
            React.createElement(Button, { m: 2, size: "small", primary: true, onClick: onOK }, "OK"))));
};
export var useForwardedRef = function (ref) {
    var innerRef = React.useRef(null);
    React.useEffect(function () {
        if (!ref) {
            return;
        }
        if (typeof ref === 'function') {
            ref(innerRef.current);
        }
        else {
            ref.current = innerRef.current;
        }
    });
    return innerRef;
};
export function withConfirm(Base) {
    return React.forwardRef(function (_a, ref) {
        var onClick = _a.onClick, confirmation = _a.confirmation, rest = __rest(_a, ["onClick", "confirmation"]);
        var targetRef = useForwardedRef(ref);
        var _b = React.useState(null), clickEvent = _b[0], setClickEvent = _b[1];
        var handleOk = React.useCallback(function () {
            if (onClick) {
                onClick(clickEvent);
            }
            setClickEvent(null);
        }, [onClick, clickEvent]);
        var handleCancel = React.useCallback(function () {
            setClickEvent(null);
        }, []);
        var handleBaseClick = React.useCallback(function (e) {
            setClickEvent(e);
        }, []);
        var confirmOptions = React.useMemo(function () {
            return typeof confirmation === 'string'
                ? {
                    text: confirmation,
                }
                : confirmation;
        }, [confirmation]);
        return (React.createElement(React.Fragment, null,
            clickEvent && (React.createElement(Confirm, __assign({}, confirmOptions, { target: targetRef.current, onOK: handleOk, onCancel: handleCancel }))),
            React.createElement(Base, __assign({}, rest, { ref: targetRef, onClick: handleBaseClick }))));
    });
}
